// const testUrl = "http://localhost:8080";
// const testUrl = 'https://tk-trade.co.kr';
const testUrl = "";

export default testUrl;
